class ApiConnect {
    static get(url: string, params?: Object): Promise {
        try {
            if (params && Object.keys(params).length > 0) {
                url += '?' + new URLSearchParams(params);
            }

            return fetch(url).then(response => {
                if (response.redirected) {
                    window.location = response.url;
                    return Promise.reject('redirect');
                }

                return response.json();
            });
        } catch (e) {
            console.error('Error: ', e);
            return Promise.reject(e);
        }
    }

    static post(url: string, params?: Object): Promise {
        try {
            return fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: params ? JSON.stringify(params) : undefined
            }).then(response => {
                if (response.redirected) {
                    window.location = response.url;
                    return Promise.reject('redirect');
                }

                return response.json();
            });
        } catch (e) {
            console.error('Error: ', e);
            return Promise.reject(e);
        }
    }

    static request(url: string, method: string, params?: Object): Promise {
        try {
            return fetch(url, {
                method: method,
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: params ? JSON.stringify(params) : undefined
            }).then(response => {
                if (response.redirected) {
                    window.location = response.url;
                    return Promise.reject('redirect');
                }

                return response.json();
            });
        } catch (e) {
            console.error('Error: ', e);
            return Promise.reject(e);
        }
    }

    static put(url: string, params?: Object): Promise {
        try {
            return fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: params ? JSON.stringify(params) : undefined
            }).then(response => {
                if (response.redirected) {
                    window.location = response.url;
                    return Promise.reject('redirect');
                }

                return response.json();
            });
        } catch (e) {
            console.error('Error: ', e);
            return Promise.reject(e);
        }
    }

    static delete(url: string, params?: Object): Promise {
        try {
            return fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: params ? JSON.stringify(params) : undefined
            }).then(response => {
                if (response.redirected) {
                    window.location = response.url;
                    return Promise.reject('redirect');
                }

                return response.json();
            });
        } catch (e) {
            console.error('Error: ', e);
            return Promise.reject(e);
        }
    }
}